import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import InfoCards from '../Components/Dashboard/InfoCards';
import RecentTabel from '../Components/Dashboard/RecentTabel';
import QuickAction from '../Components/Dashboard/QuickAction';
import VendorList from '../Components/Dashboard/VendorList';
import ProductManageTable from '../Components/Dashboard/ProductManageTable';
import Settings from '../Components/Dashboard/Settings';
import Suppliers from '../Components/Dashboard/Suppliers';
import OtherDetails from '../Components/Dashboard/OtherDetails';
import Header from '../Components/Header';
import Sidebar from '../Components/Sidebar';

export default function Dashboard() {
  return (
    <div id="dashboard-root"
      className="flex min-h-[1000px] w-full">
      {/* <!-- Sidebar --> */}
      <Sidebar />
      {/* <!-- Main Content --> */}
      <main id="main-content" className="flex-1 px-10 py-8">
        {/* <!-- Header --> */}
        <Header title="Dashboard" />
        {/* <!-- Stats Cards --> */}
        <InfoCards />

        {/* <!-- Main Grids --> */}
        <section id="main-grids" className="grid grid-cols-3 gap-7">
          {/* <!-- Left: Recent Orders --> */}
          {<RecentTabel />
            || <Skeleton count={10} />}

          {/* <!-- Right: Quick Actions & Vendors --> */}
          <div id="quick-actions-vendors" className="flex flex-col gap-7">
            {/* <!-- Quick Actions --> */}
            <QuickAction />

            {/* <!-- Vendors List --> */}
            <VendorList />
          </div>
        </section>

        {/* <!-- Products Management Table --> */}
        {<ProductManageTable />
          || <Skeleton count={10} />}

        {/* <!-- Settings, Suppliers and Other Details --> */}
        {/* <section
          id="bottom-cards-section"
          className="grid grid-cols-3 gap-7 mt-12"
        >
          <Settings />
          <Suppliers />
          <OtherDetails />
        </section> */}
      </main>
    </div>
  )
}
